export const equipmentTemplateConstants = {
  REQUEST_START: 'REQUEST_START',
  DUPLICATE_REQUEST_START: 'DUPLICATE_REQUEST_START',
  DUPLICATE_REQUEST_STOP: 'DUPLICATE_REQUEST_STOP',
  REQUEST_ERROR: 'REQUEST_ERROR',
  DUPLICATE_REQUEST_ERROR: 'DUPLICATE_REQUEST_ERROR',
  FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENT: 'FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENT',
  FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENTS: 'FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENTS',
  FETCH_EQUIPMENT_TEMPLATE_DOCUMENTS: 'FETCH_EQUIPMENT_TEMPLATE_DOCUMENTS',
  FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE: 'FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE',
  FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_SUCCESS: 'FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_SUCCESS',
  FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_ERROR: 'FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_ERROR',
  FETCH_SERVICES_FOR_EQUIPMENT_TEMPLATE: 'FETCH_SERVICES_FOR_EQUIPMENT_TEMPLATE',
  DELETE_EQUIPMENT_TEMPLATE: 'DELETE_EQUIPMENT_TEMPLATE',
  DELETE_EQUIPMENT_TEMPLATE_SUCCESS: 'DELETE_EQUIPMENT_TEMPLATE_SUCCESS',
  DELETE_EQUIPMENT_TEMPLATE_ERROR: 'DELETE_EQUIPMENT_TEMPLATE_ERROR',
  SET_EQUIPMENT_TEMPLATE_FOR_EDITING: 'SET_EQUIPMENT_TEMPLATE_FOR_EDITING',
  SAVE_EQUIPMENT_TEMPLATE: 'SAVE_EQUIPMENT_TEMPLATE',
} as const
